module.exports = __webpack_public_path__ + "static/media/as.cb630927.svg";